import moment from 'moment'
import React from 'react'
import { Convert24hrTo12hr } from 'utils/Convert24hrTo12hr'

export const getDriveMode = driveMode => {
  return driveMode?.toLowerCase().replace('_', ' ')
}

export const getDriveRoles = driveRoleMap => {
  const roles = driveRoleMap?.map(({ role }) => role?.tittle).join()
  return roles
}

export const getDriveDate = date => {
  let startDate = moment(date?.startDate)
  let endDate = moment(date?.endDate)

  const getFormat = () => {
    return `${startDate.format('DD/MM/YYYY')} - ${endDate.format('DD/MM/YYYY')}`
  }

  if (startDate.isValid()) {
    return endDate.isValid() ? getFormat() : startDate.format('DD/MM/YYYY')
  }

  return ''
}

export const getDriveTime = date => {
  let startTime = Convert24hrTo12hr(date?.startTime)
  let endTime = Convert24hrTo12hr(date?.endTime)

  let isOnlyStartTime = !!date?.endTime
  let isOnlyEndTime = !!date?.startTime

  if (!isOnlyStartTime && !isOnlyEndTime) {
    return '-'
  } else if (!isOnlyStartTime) {
    return startTime
  } else if (!isOnlyEndTime) {
    return endTime
  } else {
    return (
      <div>
        {startTime} - {endTime}
      </div>
    )
  }
}

export const toCamelCase = str => {
  const words = str?.split(' ')
  const camelCaseWords = words?.map(word => {
    return word?.charAt(0)?.toUpperCase() + word?.slice(1)?.toLowerCase()
  })
  return camelCaseWords?.join(' ')
}
